import { omit } from "lodash";
import {
	SET_CAMPAIGNS,
	SET_CAMPAIGNS_LINKS,
	UPDATE_FILTER,
	SET_FILTERS,
	SET_PARENT_OP,
} from "./types";

let initialState = () => {
	return {
		campaigns: { data: [] },
		parentOp: {data:"and"},
	};
};

export const reducer = (state = initialState(), action) => {
	switch (action.type) {
	case SET_CAMPAIGNS: {
		return { ...state, campaigns: action.data };
	}
	case SET_CAMPAIGNS_LINKS: {
		return { ...state, campaignsLinks: action.data };
	}
	case SET_FILTERS: {
		return { ...state, filters: action.data };
	}
	case UPDATE_FILTER: {
		const updatedFilters = state.filters.map((f) => {
			if (f.id == action.filter.id) {
				return action.filter;
			} else return f;
		});
		return { ...state, filters: updatedFilters };
	}
	case SET_PARENT_OP:{
		return {...state, parentOp: action.data};
	}
	default:
		const rest = omit(state, Object.keys(initialState()));
		return {
			...state,
		};
	}
};
